import {
  FilterDataType,
  IUserInfo,
  Unsubscribe,
  USER_TYPE,
} from "@home-health-notify/domain";
import { UserDirectoryContext } from "hhn-commons";
import { useCallback, useContext, useEffect, useState } from "react";
import UserDirectoryTabItem from "./UserDirectoryTabItem";

interface PhysicianDirectoryProps {
  chatID: string;
  currentUserTypes: USER_TYPE[];
}

const PhysicianDirectory = ({
  chatID,
  currentUserTypes,
}: PhysicianDirectoryProps) => {
  const { userDirectory, users } = useContext(UserDirectoryContext);
  const [filteredUserDirectory, setFilteredUserDirectory] = useState<
    IUserInfo[]
  >([]);
  const [filterTooltipData, setFilterTooltipData] = useState<FilterDataType>(
    {} as FilterDataType,
  );

  const filterDirectoryByUserType = useCallback(
    (userType: USER_TYPE[]) => {
      const filteredUsers = userDirectory.filterUserDirectory({
        userType,
        userRole: [],
      });
      setFilteredUserDirectory(filteredUsers);
    },
    [userDirectory],
  );

  useEffect(() => {
    filterDirectoryByUserType(currentUserTypes);
    // `users` triggers re-filter on user-update socket events
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterDirectoryByUserType, currentUserTypes, users]);

  useEffect(() => {
    const removeListeners: Unsubscribe[] = [];
    if (userDirectory && currentUserTypes) {
      const removeSyncUserDirectoryListener =
        userDirectory.registerSyncUserDirectoryListener(() => {
          filterDirectoryByUserType(currentUserTypes);
        });
      removeListeners.push(removeSyncUserDirectoryListener);
    }
    return () => {
      removeListeners.forEach(removeListener => removeListener());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDirectory, currentUserTypes, filterDirectoryByUserType]);

  return (
    <UserDirectoryTabItem
      chatID={chatID}
      currentUserTypes={currentUserTypes}
      defaultSelectedUserTypes={currentUserTypes}
      filterTooltipData={filterTooltipData as FilterDataType}
      setFilterTooltipData={
        setFilterTooltipData as React.Dispatch<
          React.SetStateAction<FilterDataType>
        >
      }
      filteredUserDirectory={filteredUserDirectory}
      setFilteredUserDirectory={setFilteredUserDirectory}
      testId="physician"
    />
  );
};

export default PhysicianDirectory;
